import { render } from "./Datavalidation.vue?vue&type=template&id=66c7417e&scoped=true"
import script from "./Datavalidation.vue?vue&type=script&lang=js"
export * from "./Datavalidation.vue?vue&type=script&lang=js"

import "./Datavalidation.vue?vue&type=style&index=0&id=66c7417e&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c7417e"]])

export default __exports__